export default __webpack_public_path__ + "e130714e3b550ff0a4f82dc0d2c7e566.svg";